module.exports = __webpack_public_path__ + "assets/img/sabc_main_logo.webp?a235aa6407e3b530d4781a5ff20d4ac8";